/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { TypeaheadMultiSelect } from '@components/TypeaheadMultiSelect/TypeaheadMultiSelect';
import { includes, isEmpty, sortBy } from '@utils/lodash';

export namespace MultiSelectFilter {
  export interface Props {
    id: string;
    options: TypeaheadMultiSelect.Suggestion[];
    placeholder: string;
    selections: TypeaheadMultiSelect.Selections;
    onSelectionChange: (selections: TypeaheadMultiSelect.Selections) => void;
  }
}

export const MultiSelectFilter: React.FC<MultiSelectFilter.Props> = ({
  id,
  options,
  onSelectionChange,
  selections,
  placeholder = '',
}) => {
  const getPlaceholderText = (placeholderSelections: TypeaheadMultiSelect.Selections) => {
    const selectionsArray = Object.values(placeholderSelections).map(selection => selection.display);
    if (isEmpty(selectionsArray)) {
      return placeholder;
    }
    const numSelections = selectionsArray.length;
    return numSelections > 1 ? `${numSelections} selected` : selectionsArray[0];
  };

  const getNewSuggestions = (searchString: string): TypeaheadMultiSelect.Suggestion[] => {
    const filteredSuggestions = options.filter(option => {
      return includes(option.value.toLowerCase(), searchString.toLowerCase());
    });
    return sortBy(filteredSuggestions, ['display']);
  };

  return (
    <TypeaheadMultiSelect
      id={`it-MultiSelectFilter-${id}`}
      selections={selections}
      getNewSuggestions={getNewSuggestions}
      onSelectionChange={onSelectionChange}
      getPlaceholderText={getPlaceholderText}
    />
  );
};
